<template>
  <div class="p-2 bg-white/60 rounded-xl min-h-screen">
    <!-- Bulk Store Modal -->
    <div
        v-if="showBulkStoreModal"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div class="bg-white w-full max-w-md rounded-xl shadow-xl p-4 border border-gray-200">

        <div class="flex items-center justify-between mb-3">
          <h4 class="text-base font-bold text-gray-800">انتخاب انبار برای همهٔ ردیف‌ها</h4>
          <button @click="closeBulkStoreModal" class="text-gray-500 hover:text-gray-800">
            ✕
          </button>
        </div>

        <div class="space-y-3">
          <div>
            <label class="text-sm text-gray-600 mb-1 block">انبار مورد نظر</label>
            <store-select
                v-if="stores.length > 0"
                :passed_stores="stores"
                v-model="bulkSelectedStore"
                :with_packing="true">
            </store-select>
            <p v-else class="text-xs text-gray-500">در حال بارگذاری لیست انبارها…</p>
          </div>

          <div class="text-xs text-gray-600 bg-blue-50 border border-blue-200 rounded-md p-2 leading-relaxed">
            با تایید، فیلد <code class="px-1 bg-white rounded border">to_store</code> برای <b>تمام آیتم‌ها</b> برابر با انبار انتخاب‌شده تنظیم می‌شود.
          </div>
        </div>

        <div class="mt-4 flex items-center justify-between">
          <button
              @click="closeBulkStoreModal"
              class="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50">
            انصراف
          </button>
          <button
              :disabled="!bulkSelectedStore"
              @click="applyBulkStore"
              class="px-5 py-2 rounded-lg text-white"
              :class="bulkSelectedStore ? 'bg-green-700 hover:bg-green-800' : 'bg-gray-400 cursor-not-allowed'">
            اعمال برای همه
          </button>
        </div>

      </div>
    </div>

    <div>
      <div v-if="isLoading" class="fixed inset-0 backdrop-blur-lg bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="bg-black/50 bg-opacity-95 p-2  mx-36 rounded-lg shadow-lg flex flex-col items-center">
          <div class="animate-spin rounded-full h-16 w-16 border-t-4 border-orange-300 border-solid"></div>
          <p class="mt-4 text-white text-lg">در حال انتقال...</p>
        </div>
      </div>

      <div class="bg-white rounded-lg p-2 mb-1">
        <div class="flex justify-between items-center">
          <div class="flex items-center justify-start space-x-2">

            <h3 class="text-xl font-bold text-purple-600">
              <span class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500">تحویل پکینگ {{
                  packing.title
                }}</span>
              <span v-if="packing.factor_number"
                    class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500">
              با شماره {{ packing.factor_number }}
            </span>
            </h3>
            <input
                v-model="searchGroup"
                placeholder="جستجو بر اساس sku"
                class="w-52 px-3 py-2 mr-2 border border-gray-300 rounded-md shadow-sm
             focus:outline-none ring-2 ring-pink-500  focus:ring-2 focus:ring-blue-500 focus:border-blue-500
             text-gray-700 placeholder-gray-400 bg-white"
            />
          </div>

          <div class="flex items-center justify-end">
            <button
                @click="openBulkStoreModal"
                class="px-5 ml-2 py-2 rounded-lg text-white bg-blue-600 hover:bg-blue-700 transition mr-2">
              انتخاب انبار برای همه ردیف‌ها
            </button>
            <input
                v-model="deliverCode"
                placeholder="شماره رسید (اختیاری)"
                class="w-40 px-3 py-2 border border-gray-300 rounded-md shadow-sm text-xs ml-2
             focus:outline-none ring-2 ring-green-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500
             text-gray-700 placeholder-gray-400 bg-white"
            />
            <input
                v-model="driver"
                placeholder="نام راننده"
                class="w-64 px-3 py-2 border border-gray-300 rounded-md shadow-sm text-xs
             focus:outline-none ring-2 ring-green-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500
             text-gray-700 placeholder-gray-400 bg-white"
            />
            <button @click="submitDeliver" class="px-5 py-2 rounded-lg text-white bg-green-800 hover:bg-green-900 transition mr-4">
              ثبت
            </button>
          </div>
        </div>
      </div>

    </div>

    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-md shadow-sm border border-gray-100 overflow-hidden">
      <div class="overflow-y-auto " style="max-height: calc(100vh - 28vh);">
        <table class="min-w-full text-sm">
          <thead class="bg-gray-900 border border-red-50 sticky top-0 z-10">
          <tr>
            <th class="text-[8px]  text-white text-center p-1 border  w-1">ردیف</th>
            <th class="text-[8px]  text-white text-center p-1 border w-min"></th>
            <th class="text-[8px]  text-white text-center p-1 border w-min">sku</th>
            <th class="text-[8px]  text-white text-center p-1 border w-min">قیمت مصرف کننده</th>
            <th class="text-[8px]  text-white text-center p1 border w-min">نام محصول</th>
            <th class="text-[8px]  text-white text-center p-1 border "> باقی مانده</th>
            <th class="text-[8px]  text-white text-center p-1 border ">تعداد محصول </th>
            <th class="text-[8px]  text-white text-center p-1 border ">به انبار</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in filteredItems" :key="item.id"
              class="hover:bg-gray-50 transition">
            <td class="text-center p-1 border text-[8px]">{{ index + 1 }}</td>
            <td class="text-center  items-center border w-12 p-1">
              <img
                  :src="img_source(item.pic)"
                  class="w-10 h-10 rounded-lg object-cover border border-gray-200"
              >
            </td>
            <td class="text-center  border text-[12px] w-60">
              <input
                  v-model="item.sku"
                  class="w-full h-full text-center  rounded-md bg-blue-100"
              />
            </td>
            <td class="text-center  border text-[12px] w-60">
              {{item.regular_price | toMoney(0)}}
            </td>


            <td class="text-center p-1 border text-[8px] w-36">
              {{ item && item.name !== undefined ? truncateText(item.name) : '' }}
            </td>
            <td class="text-center p-1 border w-16 bg-blue-900 text-white">{{ item.pending_items }}</td>
            <td class="text-center border p-1">
              <input
                  v-model="item.quantity"
                  type="number"
                  class="w-full h-full text-center  leading-none rounded-md bg-blue-100"
              />

            </td>
            <td class="text-center border p-2 w-40">
              <store-select
                  v-if="stores.length > 0"
                  :passed_stores="stores"
                  v-model="item.to_store"
                  :with_packing="true">
              </store-select>
            </td>
          </tr>
          <tr v-if="loading && items.length === 0">
            <td colspan="11" class="p-4 text-center">
              <div class="flex justify-center items-center gap-2">
                <svg class="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                در حال بارگذاری...
              </div>
            </td>
          </tr>
          <tr v-else-if="items.length === 0">
            <td colspan="11" class="p-4 text-center text-gray-500">
              آیتمی یافت نشد
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="showNotification"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-[90%] max-w-xs text-gray-100 bg-gray-900 rounded-lg shadow-lg border border-gray-700">

        <div
            class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-400 bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"/>
          </svg>
        </div>

        <div class="mr-3 text-sm font-normal pr-2">ثبت شد</div>

        <button @click="showNotification = false"
                class="mr-auto text-gray-400 hover:text-white rounded-lg p-1.5 hover:bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </transition>

  </div>
</template>

<script>
import PackingStoreHandle from "@/modules/store_handle/PackingStoreHandle";
import StoreSelect from "@/components/selects/StoreSelect";

export default {
  name: 'DeliverDomesticPackage',
  components: {StoreSelect, PackingStoreHandle},
  props: {
    id: {},
  },
  data() {
    return {
      showBulkStoreModal: false,
      bulkSelectedStore: null,
      searchGroup: "",
      driver: "",
      deliverCode: "",
      showNotification: false,
      isLoading: false,
      showQuickEdit: false,
      selectedProduct: null,
      selectedProductId: null,
      loading: true,
      items: [],
      stores: [],
      suppliers: [],
      packing: {},
      totalPackages: 0,
      currentPage: 1,
      activePricing: [],
      itemsPerPage: 20,
      body: {
        title: '',
        factor_number: '',
        supplier: '',
        currency: '',
        explanation: '',
        cargo_cost_per_shipping: 0,
      },
      categories: [],
      brands: [],
      productSelected: null,
      test: null,
      showProductStoreHandle: false
    }
  },
  computed: {
    filteredItems() {
      if (!this.searchGroup) return this.items
      return this.items.filter(item =>
          item.sku && item.sku.toString().includes(this.searchGroup)
      )
    },
    totalPrice() {
      return this.items.reduce((sum, item) => sum + (item.price || 0), 0);
    },
    totalPending() {
      return this.items.reduce((sum, item) => sum + (item.pending_items || 0), 0);
    },
    totalQuantity() {
      return this.items.reduce((sum, item) => sum + (item.total_quantity || 0), 0);
    },
    totalPendingItems() {
      return this.totalPending - this.items.reduce((sum, item) => sum + (item.total_quantity || 0), 0);
    },
    totalDeliverItems() {
      return this.items.reduce((sum, item) => sum + ((parseInt(item.total_quantity) || 0)), 0);
    },
    percentDeliver() {
      if (!this.totalPending) return 100;
      return Math.min(
          100,
          Math.round((this.totalDeliverItems / this.totalPending) * 100)
      );
    },

    packingTotal() {
      return this.items.reduce((sum, item) => sum + (parseInt(item.total_items) || 0), 0);
    },
    totalAmount() {
      return this.items.reduce((sum, item) => {
        const totalItems = item.total_items || item.total || 0;
        return sum + ((item.price || 0) * totalItems);
      }, 0);
    },
    visiblePages() {
      const totalPages = Math.ceil(this.totalPackages / this.itemsPerPage)
      const range = 1
      const pages = []

      pages.push(1)

      if (this.currentPage - range > 2) {
        pages.push('...')
      }

      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }

      if (this.currentPage + range < totalPages - 1) {
        pages.push('...')
      }

      if (totalPages > 1) {
        pages.push(totalPages)
      }

      return pages
    },
  },
  methods: {
    openBulkStoreModal() {
      if (!this.stores || this.stores.length === 0) {
        // اگر هنوز استورها لود نشده، یک‌بار فراخوانی کن
        this.fetchStores();
      }
      this.bulkSelectedStore = null;
      this.showBulkStoreModal = true;
    },
    closeBulkStoreModal() {
      this.showBulkStoreModal = false;
      this.bulkSelectedStore = null;
    },
    applyBulkStore() {
      if (!this.bulkSelectedStore) return;

      // اعمال روی همه آیتم‌ها (نه فقط فیلترشده‌ها)
      this.items = this.items.map(it => ({
        ...it,
        to_store: this.bulkSelectedStore
      }));

      // نوتیفیکیشن کوتاه
      this.showNotificationMessage();

      // بستن مودال
      this.closeBulkStoreModal();
    },

    calculateDeliveryPercentage() {
      if (!this.packing.total_boxes || this.packing.total_boxes === 0) return 0;
      return Math.round((this.packing.delivered_boxes / this.packing.total_boxes) * 100);
    },
    calculatePendingPercentage() {
      if (!this.packing.total_boxes || this.packing.total_boxes === 0) return 0;
      return Math.round((this.packing.pending_boxes / this.packing.total_boxes) * 100);
    },

    truncateText(text) {
      if (!text) return ''
      return text.length > 50 ? text.slice(0, 35) + '...' : text
    },
    formatPrice(price) {
      if (!price) return '0';
      return new Intl.NumberFormat('fa-IR').format(price);
    },
    calculateRowIndex(index) {
      return (this.currentPage - 1) * this.itemsPerPage + index + 1;
    },
    viewDetails(packageItem) {
      alert(`جزئیات بسته: ${packageItem.name}\nشناسه: ${packageItem.id}\nتعداد آیتم‌ها: ${packageItem.items_count}`);
    },
    downloadFile(packageItem) {
      if (!packageItem.uploaded_file) {
        this.showNotificationMessage('فایل آپلود شده موجود نیست', 'error');
        return;
      }

      this.showNotificationMessage('در حال دانلود فایل...', 'success');
      // شبیه‌سازی دانلود فایل
      setTimeout(() => {
        this.showNotificationMessage('فایل با موفقیت دانلود شد', 'success');
      }, 1500);
    },
    exportToExcel() {
      this.showNotificationMessage('در حال آماده‌سازی خروجی Excel...', 'success');
      // شبیه‌سازی تولید فایل Excel
      setTimeout(() => {
        this.showNotificationMessage('خروجی Excel با موفقیت تولید شد', 'success');
      }, 2000);
    },

    isActive(product) {
      return this.activePricing.some(p => p === product);
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    submitDeliver() {
      if (!this.driver){
        window.alert('نام راننده را وارد کنید')
        return
      }
      let body = {
        "package": this.id,
        "driver_name": this.driver,
        "driver_mobile_number": "",
        "document_number": this.deliverCode,
        "items": []

      }
      for (let item of this.items){
        if (item.quantity ) {
          body.items.push({
            "package_item": item.id,
            "sku": item.sku,
            "to_store": item.to_store,
            "total_quantity": parseInt(item.quantity)
          })
        }
      }
      if (body.items.length === 0){
        window.alert('حداقل یک ردیف وارد کنید')
        return
      }
      this.isLoading = true
      this.request({
        url: this.endpoint(`entrance/domesticDeliveries/create`),
        method: 'post',
        data: body,
        success: (data) => {
          this.showNotificationMessage()
          setTimeout(() => {
            this.$router.push(`/panel/domesticPackageDeliveries`)
            this.isLoading = false
          }, 3000);
        },
        error: (error) => {
          window.alert(error)
          this.isLoading = false
        }

      })
    },
    fetchPacking() {
      this.isLoading = true

      this.request({
        url: this.endpoint(`entrance/pendingDomesticEntrancePackage/${this.id}`),
        method: 'get',
        success: (data) => {
          console.log(data.pending_rows)
          console.log(data.items)
          this.packing = data
          this.items = data.pending_rows || []
          this.totalPackages = this.pending_rows.length
          this.isLoading = false
        },
        error: () => {
          this.isLoading = false
        }
      })
    },

    applyFilters() {
      this.currentPage = 1
      this.fetchPacking()
    },

    resetFilters() {
      this.filters = {
        id_in: '',
        name__icontains: '',
      }
      this.applyFilters()
    },

    refreshProducts() {
      this.fetchPacking()
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchPacking()
      }
    },

    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalPackages) {
        this.currentPage++
        this.fetchPacking()
      }
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.fetchPacking()
      }
    },
    productStoreHandle(product) {
      this.selectedProduct = product
      this.showProductStoreHandle = true

    },
    active(product) {
      const index = this.activePricing.indexOf(product);
      if (index > -1) {
        this.activePricing.splice(index, 1);
      } else {
        this.activePricing.push(product);
      }
    },
    calculate_discount(price, discount) {
      return price - (price / 100 * discount)
    },
    closeProductStoreHandle() {
      this.selectedProduct = null
      this.showProductStoreHandle = false
    },

    fetchStores() {
      this.request({
        url: this.endpoint(`main/store`),
        method: "get",
        success: data => {
          this.stores = data
          console.log(this.stores)
        }
      })
    },
    fetchSuppliers() {
      this.request({
        url: this.endpoint('main/supplier'),
        method: 'get',
        success: (data) => {
          this.suppliers = data
        }
      })
    },

  },
  mounted() {
    this.fetchStores()
    this.fetchSuppliers()
    this.fetchPacking()
  }
}
</script>

<style>
/* RTL support */
body {
  direction: rtl;
  text-align: right;
}

/* Glass morphism effect */
.glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

/* Neumorphism effect */
.neumorphism {
  border-radius: 16px;
  background: #f0f0f0;
  box-shadow: 8px 8px 16px #d9d9d9,
  -8px -8px 16px #ffffff;
}

/* Smooth transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.glass-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.bg-secondary {
  background-color: #424242;
}

.data-card {
  transition: all 0.3s ease;
  box-shadow: 0 10px 25px -5px rgba(14, 165, 233, 0.1);
}

.data-card:hover {
  box-shadow: 0 20px 35px -5px rgba(14, 165, 233, 0.15);
  transform: translateY(-2px);
}

.data-item {
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
}

.data-item:hover {
  border-left-color: #ff8700;
}

.animate-pulse-slow {
  animation: pulse 3s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.9;
  }
}
</style>